/**
 * IXD 값 편집기 진입 시 `워크북 값 불러오기` 버튼을 가리키는 안내 tooltip 의 노출 예산.
 *
 * 통합 안내 **모달**은 횟수 제한이 없다 — 메뉴를 누를 때마다 뜬다. 예산은 들어갈 때마다
 * 저절로 뜨는 tooltip 에만 건다.
 * (유저 단위 저장소가 없어 브라우저 localStorage 에 센다 — 계정 하나에 브라우저 하나 기준)
 */

const VIEWS_KEY = "ixd-workbook-load-guide-views";

/** tooltip 을 자동으로 띄우는 최대 횟수. */
export const MAX_GUIDE_VIEWS = 5;

/** 노출 한 번을 당겨 쓴다. 남은 횟수가 없으면 false. */
export const takeWorkbookLoadGuideView = (): boolean => {
  try {
    const seen = Number(localStorage.getItem(VIEWS_KEY)) || 0;
    if (seen >= MAX_GUIDE_VIEWS) return false;
    localStorage.setItem(VIEWS_KEY, String(seen + 1));
    return true;
  } catch {
    // 셀 수 없는 환경(시크릿/정책)에서는 안내를 막지 않는다 — 통합 사실이 더 중요하다
    return true;
  }
};
